document.addEventListener('DOMContentLoaded', function () {
    const toggleButton = document.querySelector('.btn__state');
    const collapseElement = document.querySelector(toggleButton.getAttribute('data-target'));

    // Add the 'show' class by default
    collapseElement.classList.add('show');
    toggleButton.setAttribute('aria-expanded', 'true');

    toggleButton.addEventListener('click', function () {
        const isExpanded = toggleButton.getAttribute('aria-expanded') === 'true';
        
        toggleButton.setAttribute('aria-expanded', !isExpanded);
        collapseElement.classList.toggle('show');
    });
});
document.addEventListener('DOMContentLoaded', function() {
    const quantityInput = document.querySelector('.product-form__input--quantity');
    const increaseBtn = document.querySelector('.product__quantity__btn--up');
    const decreaseBtn = document.querySelector('.product__quantity__btn--down');

    increaseBtn.addEventListener('click', function() {
        let currentValue = parseInt(quantityInput.value);
        quantityInput.value = currentValue + 1;
    });

    decreaseBtn.addEventListener('click', function() {
        let currentValue = parseInt(quantityInput.value);
        if (currentValue > 1) {
            quantityInput.value = currentValue - 1;
        }
    });
});
 
 


 